import {
	useMutation,
	UseMutationResult,
	useQuery,
	useQueryClient,
	UseQueryResult,
} from '@tanstack/react-query'

import { PaymentToken } from '@/core/api/entities/paymentToken'
import { PaymentTokenMapper } from '@/core/api/mappers/paymentTokenMapper'
import { paymentService } from '@/core/api/services/paymentService'
import { DEFAULT_PARAMS } from '@/core/hooks/common'

export const usePaymentTokens = ({
	config,
	options,
}: {
	config?: any
	options?: any
} = DEFAULT_PARAMS): UseQueryResult<PaymentToken[], Error> => {
	const queryKey = ['paymentTokens', { ...config?.params }]

	return useQuery({
		queryKey,
		queryFn: () =>
			paymentService.getPaymentTokens(config).then((response) => {
				return PaymentTokenMapper.toEntities(response.data.data)
			}),
		staleTime: 5 * 60 * 1000, // 5 minutes
		gcTime: 10 * 60 * 1000, // 10 minutes
		...options,
	})
}

export const useDeletePaymentToken = ({
	config,
	options,
}: {
	config?: any
	options?: any
} = DEFAULT_PARAMS): UseMutationResult<void, Error, number, any> => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (paymentTokenId: number) =>
			paymentService.deletePaymentToken(paymentTokenId, config),
		onSettled: () => {
			// Invalidate payment tokens query to refresh the list after mutation completes
			queryClient.invalidateQueries({ queryKey: ['paymentTokens'] })
		},
		...options,
	})
}
